import React, { useState, useEffect } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../common/loader/Loader";
import { isTokenExpired, clearAuthSession } from "../../utils/utils";
import { addLoginUser, setIsLogin } from "../../actions/Users";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const user = useSelector((state) => state?.user);
  const authToken = localStorage.getItem("authToken");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [user, authToken]);

  const tokenExpired = isTokenExpired(authToken);
  if (tokenExpired && authToken) {
    clearAuthSession();
    if (user?.loginuser && Object.keys(user.loginuser).length > 0) {
      dispatch(addLoginUser({}));
      dispatch(setIsLogin(false));
    }
  }

  const isAuthenticated =
    user?.loginuser && Object.keys(user.loginuser).length > 0 && authToken && !tokenExpired;

  if (loading) {
    return <Loader />;
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/login-office",
              state: { from: location.pathname + location.search },
            }}
          />
        )
      }
    />
  );
};

export default ProtectedRoute;
